/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProductWhereToShopCategoryCreateRequest } from '../models/product-where-to-shop-category-create-request';
import { ProductWhereToShopCategoryCreateResponse } from '../models/product-where-to-shop-category-create-response';
import { ProductWhereToShopCategoryListResponse } from '../models/product-where-to-shop-category-list-response';
import { ProductWhereToShopCategoryUpdateRequest } from '../models/product-where-to-shop-category-update-request';
import { ProductWhereToShopCategoryUpdateResponse } from '../models/product-where-to-shop-category-update-response';
import { ProductWhereToShopClickLeaderboardRequest } from '../models/product-where-to-shop-click-leaderboard-request';
import { ProductWhereToShopClickLeaderboardResponse } from '../models/product-where-to-shop-click-leaderboard-response';
import { ProductWhereToShopClickListRequest } from '../models/product-where-to-shop-click-list-request';
import { ProductWhereToShopClickListResponse } from '../models/product-where-to-shop-click-list-response';
import { ProductWhereToShopClickSaveRequest } from '../models/product-where-to-shop-click-save-request';
import { ProductWhereToShopClickSpendNotification } from '../models/product-where-to-shop-click-spend-notification';
import { ProductWhereToShopClickStatRequest } from '../models/product-where-to-shop-click-stat-request';
import { ProductWhereToShopClickStatResponse } from '../models/product-where-to-shop-click-stat-response';
import { ProductWhereToShopListRequest } from '../models/product-where-to-shop-list-request';
import { ProductWhereToShopListResponse } from '../models/product-where-to-shop-list-response';
import { ProductWhereToShopMerchantCategoryAssignRequest } from '../models/product-where-to-shop-merchant-category-assign-request';
import { ProductWhereToShopMerchantCategoryAssignResponse } from '../models/product-where-to-shop-merchant-category-assign-response';
import { ProductWhereToShopMerchantCategoryOrderRequest } from '../models/product-where-to-shop-merchant-category-order-request';
import { ProductWhereToShopMerchantCategoryOrderResponse } from '../models/product-where-to-shop-merchant-category-order-response';
import { ProductWhereToShopMerchantCategoryRevokeRequest } from '../models/product-where-to-shop-merchant-category-revoke-request';
import { ProductWhereToShopMerchantCategoryRevokeResponse } from '../models/product-where-to-shop-merchant-category-revoke-response';
import { ProductWhereToShopMerchantCreateRequest } from '../models/product-where-to-shop-merchant-create-request';
import { ProductWhereToShopMerchantCreateResponse } from '../models/product-where-to-shop-merchant-create-response';
import { ProductWhereToShopMerchantListResponse } from '../models/product-where-to-shop-merchant-list-response';
import { ProductWhereToShopMerchantUpdateRequest } from '../models/product-where-to-shop-merchant-update-request';
import { ProductWhereToShopMerchantUpdateResponse } from '../models/product-where-to-shop-merchant-update-response';
import { ProductWhereToShopSourceStatsRequest } from '../models/product-where-to-shop-source-stats-request';
import { ProductWhereToShopSourceStatsResponse } from '../models/product-where-to-shop-source-stats-response';

@Injectable({
  providedIn: 'root',
})
export class WhereToShopService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation v1WhereToShopPost
   */
  static readonly V1WhereToShopPostPath = '/v1/where-to-shop';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopPost$Plain$Response(params?: {
    body?: ProductWhereToShopListRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopPost$Plain(params?: {
    body?: ProductWhereToShopListRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopListResponse> {

    return this.v1WhereToShopPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopListResponse>) => r.body as ProductWhereToShopListResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopPost$Json$Response(params?: {
    body?: ProductWhereToShopListRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopPost$Json(params?: {
    body?: ProductWhereToShopListRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopListResponse> {

    return this.v1WhereToShopPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopListResponse>) => r.body as ProductWhereToShopListResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopMerchantListProductIdGet
   */
  static readonly V1WhereToShopMerchantListProductIdGetPath = '/v1/where-to-shop/merchant/list/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantListProductIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1WhereToShopMerchantListProductIdGet$Plain$Response(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantListProductIdGetPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantListProductIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1WhereToShopMerchantListProductIdGet$Plain(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantListResponse> {

    return this.v1WhereToShopMerchantListProductIdGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantListResponse>) => r.body as ProductWhereToShopMerchantListResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantListProductIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1WhereToShopMerchantListProductIdGet$Json$Response(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantListProductIdGetPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantListProductIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1WhereToShopMerchantListProductIdGet$Json(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantListResponse> {

    return this.v1WhereToShopMerchantListProductIdGet$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantListResponse>) => r.body as ProductWhereToShopMerchantListResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopMerchantCreatePost
   */
  static readonly V1WhereToShopMerchantCreatePostPath = '/v1/where-to-shop/merchant/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantCreatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCreatePost$Plain$Response(params?: {
    body?: ProductWhereToShopMerchantCreateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantCreateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantCreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantCreateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantCreatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCreatePost$Plain(params?: {
    body?: ProductWhereToShopMerchantCreateRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantCreateResponse> {

    return this.v1WhereToShopMerchantCreatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantCreateResponse>) => r.body as ProductWhereToShopMerchantCreateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantCreatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCreatePost$Json$Response(params?: {
    body?: ProductWhereToShopMerchantCreateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantCreateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantCreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantCreateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantCreatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCreatePost$Json(params?: {
    body?: ProductWhereToShopMerchantCreateRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantCreateResponse> {

    return this.v1WhereToShopMerchantCreatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantCreateResponse>) => r.body as ProductWhereToShopMerchantCreateResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopMerchantUpdatePost
   */
  static readonly V1WhereToShopMerchantUpdatePostPath = '/v1/where-to-shop/merchant/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantUpdatePost$Plain$Response(params?: {
    body?: ProductWhereToShopMerchantUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantUpdatePost$Plain(params?: {
    body?: ProductWhereToShopMerchantUpdateRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantUpdateResponse> {

    return this.v1WhereToShopMerchantUpdatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantUpdateResponse>) => r.body as ProductWhereToShopMerchantUpdateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantUpdatePost$Json$Response(params?: {
    body?: ProductWhereToShopMerchantUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantUpdatePost$Json(params?: {
    body?: ProductWhereToShopMerchantUpdateRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantUpdateResponse> {

    return this.v1WhereToShopMerchantUpdatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantUpdateResponse>) => r.body as ProductWhereToShopMerchantUpdateResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopCategoryListProductIdGet
   */
  static readonly V1WhereToShopCategoryListProductIdGetPath = '/v1/where-to-shop/category/list/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopCategoryListProductIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1WhereToShopCategoryListProductIdGet$Plain$Response(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopCategoryListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopCategoryListProductIdGetPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopCategoryListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopCategoryListProductIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1WhereToShopCategoryListProductIdGet$Plain(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<ProductWhereToShopCategoryListResponse> {

    return this.v1WhereToShopCategoryListProductIdGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopCategoryListResponse>) => r.body as ProductWhereToShopCategoryListResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopCategoryListProductIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1WhereToShopCategoryListProductIdGet$Json$Response(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopCategoryListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopCategoryListProductIdGetPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopCategoryListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopCategoryListProductIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1WhereToShopCategoryListProductIdGet$Json(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<ProductWhereToShopCategoryListResponse> {

    return this.v1WhereToShopCategoryListProductIdGet$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopCategoryListResponse>) => r.body as ProductWhereToShopCategoryListResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopCategoryCreatePost
   */
  static readonly V1WhereToShopCategoryCreatePostPath = '/v1/where-to-shop/category/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopCategoryCreatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopCategoryCreatePost$Plain$Response(params?: {
    body?: ProductWhereToShopCategoryCreateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopCategoryCreateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopCategoryCreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopCategoryCreateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopCategoryCreatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopCategoryCreatePost$Plain(params?: {
    body?: ProductWhereToShopCategoryCreateRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopCategoryCreateResponse> {

    return this.v1WhereToShopCategoryCreatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopCategoryCreateResponse>) => r.body as ProductWhereToShopCategoryCreateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopCategoryCreatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopCategoryCreatePost$Json$Response(params?: {
    body?: ProductWhereToShopCategoryCreateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopCategoryCreateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopCategoryCreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopCategoryCreateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopCategoryCreatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopCategoryCreatePost$Json(params?: {
    body?: ProductWhereToShopCategoryCreateRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopCategoryCreateResponse> {

    return this.v1WhereToShopCategoryCreatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopCategoryCreateResponse>) => r.body as ProductWhereToShopCategoryCreateResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopCategoryUpdatePost
   */
  static readonly V1WhereToShopCategoryUpdatePostPath = '/v1/where-to-shop/category/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopCategoryUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopCategoryUpdatePost$Plain$Response(params?: {
    body?: ProductWhereToShopCategoryUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopCategoryUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopCategoryUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopCategoryUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopCategoryUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopCategoryUpdatePost$Plain(params?: {
    body?: ProductWhereToShopCategoryUpdateRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopCategoryUpdateResponse> {

    return this.v1WhereToShopCategoryUpdatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopCategoryUpdateResponse>) => r.body as ProductWhereToShopCategoryUpdateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopCategoryUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopCategoryUpdatePost$Json$Response(params?: {
    body?: ProductWhereToShopCategoryUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopCategoryUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopCategoryUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopCategoryUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopCategoryUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopCategoryUpdatePost$Json(params?: {
    body?: ProductWhereToShopCategoryUpdateRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopCategoryUpdateResponse> {

    return this.v1WhereToShopCategoryUpdatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopCategoryUpdateResponse>) => r.body as ProductWhereToShopCategoryUpdateResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopMerchantCategoryAssignPost
   */
  static readonly V1WhereToShopMerchantCategoryAssignPostPath = '/v1/where-to-shop/merchant/category/assign';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantCategoryAssignPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryAssignPost$Plain$Response(params?: {
    body?: ProductWhereToShopMerchantCategoryAssignRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantCategoryAssignResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantCategoryAssignPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantCategoryAssignResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantCategoryAssignPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryAssignPost$Plain(params?: {
    body?: ProductWhereToShopMerchantCategoryAssignRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantCategoryAssignResponse> {

    return this.v1WhereToShopMerchantCategoryAssignPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantCategoryAssignResponse>) => r.body as ProductWhereToShopMerchantCategoryAssignResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantCategoryAssignPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryAssignPost$Json$Response(params?: {
    body?: ProductWhereToShopMerchantCategoryAssignRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantCategoryAssignResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantCategoryAssignPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantCategoryAssignResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantCategoryAssignPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryAssignPost$Json(params?: {
    body?: ProductWhereToShopMerchantCategoryAssignRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantCategoryAssignResponse> {

    return this.v1WhereToShopMerchantCategoryAssignPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantCategoryAssignResponse>) => r.body as ProductWhereToShopMerchantCategoryAssignResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopMerchantCategoryRevokePost
   */
  static readonly V1WhereToShopMerchantCategoryRevokePostPath = '/v1/where-to-shop/merchant/category/revoke';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantCategoryRevokePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryRevokePost$Plain$Response(params?: {
    body?: ProductWhereToShopMerchantCategoryRevokeRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantCategoryRevokeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantCategoryRevokePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantCategoryRevokeResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantCategoryRevokePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryRevokePost$Plain(params?: {
    body?: ProductWhereToShopMerchantCategoryRevokeRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantCategoryRevokeResponse> {

    return this.v1WhereToShopMerchantCategoryRevokePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantCategoryRevokeResponse>) => r.body as ProductWhereToShopMerchantCategoryRevokeResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantCategoryRevokePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryRevokePost$Json$Response(params?: {
    body?: ProductWhereToShopMerchantCategoryRevokeRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantCategoryRevokeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantCategoryRevokePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantCategoryRevokeResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantCategoryRevokePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryRevokePost$Json(params?: {
    body?: ProductWhereToShopMerchantCategoryRevokeRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantCategoryRevokeResponse> {

    return this.v1WhereToShopMerchantCategoryRevokePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantCategoryRevokeResponse>) => r.body as ProductWhereToShopMerchantCategoryRevokeResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopMerchantCategoryOrderPost
   */
  static readonly V1WhereToShopMerchantCategoryOrderPostPath = '/v1/where-to-shop/merchant/category/order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantCategoryOrderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryOrderPost$Plain$Response(params?: {
    body?: ProductWhereToShopMerchantCategoryOrderRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantCategoryOrderResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantCategoryOrderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantCategoryOrderResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantCategoryOrderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryOrderPost$Plain(params?: {
    body?: ProductWhereToShopMerchantCategoryOrderRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantCategoryOrderResponse> {

    return this.v1WhereToShopMerchantCategoryOrderPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantCategoryOrderResponse>) => r.body as ProductWhereToShopMerchantCategoryOrderResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopMerchantCategoryOrderPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryOrderPost$Json$Response(params?: {
    body?: ProductWhereToShopMerchantCategoryOrderRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopMerchantCategoryOrderResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopMerchantCategoryOrderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopMerchantCategoryOrderResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopMerchantCategoryOrderPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopMerchantCategoryOrderPost$Json(params?: {
    body?: ProductWhereToShopMerchantCategoryOrderRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopMerchantCategoryOrderResponse> {

    return this.v1WhereToShopMerchantCategoryOrderPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopMerchantCategoryOrderResponse>) => r.body as ProductWhereToShopMerchantCategoryOrderResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopClickPost
   */
  static readonly V1WhereToShopClickPostPath = '/v1/where-to-shop/click';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopClickPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickPost$Response(params?: {
    body?: ProductWhereToShopClickSaveRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopClickPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopClickPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickPost(params?: {
    body?: ProductWhereToShopClickSaveRequest
  },
  context?: HttpContext

): Observable<void> {

    return this.v1WhereToShopClickPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation v1WhereToShopClickLeaderboardPost
   */
  static readonly V1WhereToShopClickLeaderboardPostPath = '/v1/where-to-shop/click/leaderboard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopClickLeaderboardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickLeaderboardPost$Plain$Response(params?: {
    body?: ProductWhereToShopClickLeaderboardRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopClickLeaderboardResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopClickLeaderboardPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopClickLeaderboardResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopClickLeaderboardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickLeaderboardPost$Plain(params?: {
    body?: ProductWhereToShopClickLeaderboardRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopClickLeaderboardResponse> {

    return this.v1WhereToShopClickLeaderboardPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopClickLeaderboardResponse>) => r.body as ProductWhereToShopClickLeaderboardResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopClickLeaderboardPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickLeaderboardPost$Json$Response(params?: {
    body?: ProductWhereToShopClickLeaderboardRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopClickLeaderboardResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopClickLeaderboardPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopClickLeaderboardResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopClickLeaderboardPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickLeaderboardPost$Json(params?: {
    body?: ProductWhereToShopClickLeaderboardRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopClickLeaderboardResponse> {

    return this.v1WhereToShopClickLeaderboardPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopClickLeaderboardResponse>) => r.body as ProductWhereToShopClickLeaderboardResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopClickListPost
   */
  static readonly V1WhereToShopClickListPostPath = '/v1/where-to-shop/click/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopClickListPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickListPost$Plain$Response(params?: {
    body?: ProductWhereToShopClickListRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopClickListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopClickListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopClickListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopClickListPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickListPost$Plain(params?: {
    body?: ProductWhereToShopClickListRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopClickListResponse> {

    return this.v1WhereToShopClickListPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopClickListResponse>) => r.body as ProductWhereToShopClickListResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopClickListPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickListPost$Json$Response(params?: {
    body?: ProductWhereToShopClickListRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopClickListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopClickListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopClickListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopClickListPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickListPost$Json(params?: {
    body?: ProductWhereToShopClickListRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopClickListResponse> {

    return this.v1WhereToShopClickListPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopClickListResponse>) => r.body as ProductWhereToShopClickListResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopSourceStatsPost
   */
  static readonly V1WhereToShopSourceStatsPostPath = '/v1/where-to-shop/source/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopSourceStatsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopSourceStatsPost$Plain$Response(params?: {
    body?: ProductWhereToShopSourceStatsRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopSourceStatsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopSourceStatsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopSourceStatsResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopSourceStatsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopSourceStatsPost$Plain(params?: {
    body?: ProductWhereToShopSourceStatsRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopSourceStatsResponse> {

    return this.v1WhereToShopSourceStatsPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopSourceStatsResponse>) => r.body as ProductWhereToShopSourceStatsResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopSourceStatsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopSourceStatsPost$Json$Response(params?: {
    body?: ProductWhereToShopSourceStatsRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopSourceStatsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopSourceStatsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopSourceStatsResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopSourceStatsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopSourceStatsPost$Json(params?: {
    body?: ProductWhereToShopSourceStatsRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopSourceStatsResponse> {

    return this.v1WhereToShopSourceStatsPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopSourceStatsResponse>) => r.body as ProductWhereToShopSourceStatsResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopClickStatsPost
   */
  static readonly V1WhereToShopClickStatsPostPath = '/v1/where-to-shop/click/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopClickStatsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickStatsPost$Plain$Response(params?: {
    body?: ProductWhereToShopClickStatRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopClickStatResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopClickStatsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopClickStatResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopClickStatsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickStatsPost$Plain(params?: {
    body?: ProductWhereToShopClickStatRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopClickStatResponse> {

    return this.v1WhereToShopClickStatsPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopClickStatResponse>) => r.body as ProductWhereToShopClickStatResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopClickStatsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickStatsPost$Json$Response(params?: {
    body?: ProductWhereToShopClickStatRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductWhereToShopClickStatResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopClickStatsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductWhereToShopClickStatResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopClickStatsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickStatsPost$Json(params?: {
    body?: ProductWhereToShopClickStatRequest
  },
  context?: HttpContext

): Observable<ProductWhereToShopClickStatResponse> {

    return this.v1WhereToShopClickStatsPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductWhereToShopClickStatResponse>) => r.body as ProductWhereToShopClickStatResponse)
    );
  }

  /**
   * Path part for operation v1WhereToShopClickSpendPost
   */
  static readonly V1WhereToShopClickSpendPostPath = '/v1/where-to-shop/click/spend';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1WhereToShopClickSpendPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickSpendPost$Response(params?: {
    body?: ProductWhereToShopClickSpendNotification
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WhereToShopService.V1WhereToShopClickSpendPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1WhereToShopClickSpendPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1WhereToShopClickSpendPost(params?: {
    body?: ProductWhereToShopClickSpendNotification
  },
  context?: HttpContext

): Observable<void> {

    return this.v1WhereToShopClickSpendPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
